import QRCode from 'qrcode';

const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content || '';

function showToast(message, tone = 'success') {
  const toast = document.getElementById('toast');
  if (!toast) return;
  toast.textContent = message;
  toast.className = `toast show ${tone}`;
  window.clearTimeout(showToast.timer);
  showToast.timer = window.setTimeout(() => { toast.className = 'toast'; }, 2600);
}

async function requestJSON(url, options = {}) {
  const headers = new Headers(options.headers || {});
  headers.set('X-Requested-With', 'XMLHttpRequest');
  if (csrfToken) headers.set('X-CSRF-Token', csrfToken);
  const response = await fetch(url, { credentials: 'same-origin', ...options, headers });
  let payload;
  try {
    payload = await response.json();
  } catch (_) {
    throw new Error('服务器返回了无法识别的响应');
  }
  if (!response.ok || Number(payload.code) !== 0) {
    throw new Error(payload.message || '请求失败，请稍后再试');
  }
  return payload.data;
}

async function copyText(value) {
  try {
    await navigator.clipboard.writeText(value);
  } catch (_) {
    const input = document.createElement('textarea');
    input.value = value;
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    input.remove();
  }
  showToast('已复制到剪贴板');
}

document.addEventListener('click', (event) => {
  const direct = event.target.closest('[data-copy]');
  if (direct) {
    event.preventDefault();
    copyText(direct.dataset.copy || '');
    return;
  }
  const targetButton = event.target.closest('[data-copy-target]');
  if (targetButton) {
    event.preventDefault();
    copyText(document.getElementById(targetButton.dataset.copyTarget)?.textContent || '');
  }
});

function yuan(cents) {
  return (Number(cents || 0) / 100).toFixed(2);
}

function appendText(parent, tag, text, className = '') {
  const element = document.createElement(tag);
  if (className) element.className = className;
  element.textContent = text;
  parent.appendChild(element);
  return element;
}

function renderCards(container, cards) {
  container.replaceChildren();
  (cards || []).forEach((card, index) => {
    const article = document.createElement('article');
    article.className = 'delivered-card';
    appendText(article, 'span', `卡密 ${index + 1}`, 'section-kicker');
    const secret = appendText(article, 'pre', String(card.secret || ''));
    const button = appendText(article, 'button', '复制卡密', 'small-button');
    button.type = 'button';
    button.addEventListener('click', () => copyText(secret.textContent || ''));
    if (card.buyer_note) appendText(article, 'p', String(card.buyer_note));
    container.appendChild(article);
  });
}

function initPurchaseForm() {
  const form = document.getElementById('purchase-form');
  if (!form) return;
  const quantity = form.querySelector('#quantity');
  const price = form.querySelector('#total-price');
  const error = form.querySelector('#purchase-error');
  const submit = form.querySelector('button[type="submit"]');
  let selected = form.querySelector('input[name="variant_id"]:checked');
  if (!selected || selected.disabled) {
    selected = form.querySelector('input[name="variant_id"]:not(:disabled)');
    if (selected) selected.checked = true;
  }

  const refresh = () => {
    selected = form.querySelector('input[name="variant_id"]:checked');
    if (!selected) {
      price.textContent = '0.00';
      if (submit) submit.disabled = true;
      return;
    }
    const minimum = Math.max(1, Number(selected.dataset.min || 1));
    const maximum = Math.max(minimum, Math.min(Number(selected.dataset.max || minimum), Number(selected.dataset.stock || 0)));
    quantity.min = String(minimum);
    quantity.max = String(maximum);
    const current = Math.max(minimum, Math.min(maximum, Number(quantity.value || minimum)));
    quantity.value = String(current);
    price.textContent = yuan(Number(selected.dataset.price || 0) * current);
  };

  form.addEventListener('change', (event) => {
    if (event.target.matches('input[name="variant_id"], #quantity')) refresh();
  });
  form.addEventListener('input', (event) => {
    if (event.target === quantity) refresh();
  });
  form.querySelectorAll('[data-qty]').forEach((button) => {
    button.addEventListener('click', () => {
      const step = button.dataset.qty === 'plus' ? 1 : -1;
      quantity.value = String(Number(quantity.value || 1) + step);
      refresh();
    });
  });
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    error.textContent = '';
    if (submit) submit.disabled = true;
    try {
      const data = await requestJSON('/api/orders', { method: 'POST', body: new FormData(form) });
      window.location.assign(`/checkout/${encodeURIComponent(data.token)}`);
    } catch (exception) {
      error.textContent = exception.message;
      if (submit) submit.disabled = false;
    }
  });
  refresh();
}

function initCheckout() {
  const app = document.getElementById('checkout-app');
  if (!app) return;
  const token = app.dataset.token || '';
  const payLink = document.getElementById('payment-link');
  const help = document.getElementById('payment-help');
  const error = document.getElementById('checkout-error');
  const paymentStage = document.getElementById('payment-stage');
  const deliveryStage = document.getElementById('delivery-stage');
  const exceptionStage = document.getElementById('exception-stage');
  const cards = document.getElementById('delivered-cards');
  const title = document.getElementById('checkout-title');
  const subtitle = document.getElementById('checkout-subtitle');
  const orb = document.getElementById('status-orb');
  const countdown = document.getElementById('countdown');
  const qr = document.getElementById('payment-qr');
  let status;
  try { status = JSON.parse(app.dataset.initial || '{}'); } catch (_) { status = {}; }
  let expiresAt = new Date(String(status.expires_at || '').replace(' ', 'T'));
  let stopped = false;

  const applyTarget = async (target) => {
    if (!target?.kind || !target?.value) return;
    if (target.kind === 'qrcode') {
      qr.hidden = false;
      payLink.hidden = true;
      help.textContent = '请使用对应支付应用扫描二维码';
      try {
        await QRCode.toCanvas(qr, target.value, { width: 220, margin: 1, errorCorrectionLevel: 'M' });
      } catch (_) {
        qr.hidden = true;
        payLink.hidden = false;
        payLink.href = target.value;
        payLink.textContent = '打开支付页面 →';
      }
      return;
    }
    qr.hidden = true;
    payLink.hidden = false;
    payLink.href = target.value;
    if (target.kind === 'redirect') {
      window.location.assign(target.value);
      return;
    }
    payLink.textContent = '唤起支付客户端 →';
    help.textContent = '如未自动唤起，请点击上方按钮';
    window.location.href = target.value;
  };

  const render = (next) => {
    status = next || status;
    expiresAt = new Date(String(status.expires_at || '').replace(' ', 'T'));
    if (status.payment_status === 'paid' && status.fulfillment_status === 'delivered') {
      stopped = true;
      paymentStage.hidden = true;
      exceptionStage.hidden = true;
      deliveryStage.hidden = false;
      title.textContent = '支付成功';
      subtitle.textContent = '卡密已完成交付，请立即复制并妥善保存。';
      orb.textContent = '✓';
      orb.className = 'status-orb success';
      renderCards(cards, status.cards || []);
    } else if (status.payment_status === 'paid' && status.fulfillment_status === 'exception') {
      stopped = true;
      paymentStage.hidden = true;
      deliveryStage.hidden = true;
      exceptionStage.hidden = false;
      title.textContent = '已付款待处理';
      subtitle.textContent = '订单已安全记录，商家补充库存后可以继续发卡。';
      orb.textContent = '!';
      orb.className = 'status-orb exception';
    } else if (['expired', 'failed'].includes(status.payment_status)) {
      stopped = true;
      paymentStage.hidden = true;
      title.textContent = status.payment_status === 'expired' ? '订单已过期' : '支付未完成';
      subtitle.textContent = '本订单已不能继续支付，请返回商品页面重新下单。';
      orb.textContent = '×';
      orb.className = 'status-orb expired';
    }
  };

  const refreshCountdown = () => {
    if (stopped || Number.isNaN(expiresAt.getTime())) return;
    const seconds = Math.max(0, Math.floor((expiresAt.getTime() - Date.now()) / 1000));
    const minutes = String(Math.floor(seconds / 60)).padStart(2, '0');
    const remainder = String(seconds % 60).padStart(2, '0');
    countdown.textContent = `${minutes}:${remainder}`;
  };

  payLink.addEventListener('click', async (event) => {
    if (payLink.getAttribute('href') !== '#') return;
    event.preventDefault();
    payLink.classList.add('loading');
    payLink.textContent = '正在连接支付网关…';
    error.textContent = '';
    try {
      const target = await requestJSON(`/api/orders/${encodeURIComponent(token)}/payment`, { method: 'POST' });
      await applyTarget(target);
    } catch (exception) {
      error.textContent = exception.message;
      payLink.classList.remove('loading');
      payLink.textContent = '重新发起支付 →';
    }
  });

  render(status);
  if (!stopped && app.dataset.targetKind && app.dataset.targetValue) {
    applyTarget({ kind: app.dataset.targetKind, value: app.dataset.targetValue });
  }
  refreshCountdown();
  window.setInterval(refreshCountdown, 1000);
  window.setInterval(async () => {
    if (stopped || document.hidden) return;
    try { render(await requestJSON(`/api/orders/${encodeURIComponent(token)}/status`)); } catch (_) { /* retry on next poll */ }
  }, 3000);
}

function statusLabel(value) {
  return ({ pending: '待支付', paid: '已付款', expired: '已过期', failed: '支付失败', delivered: '已交付', exception: '待人工处理' })[value] || value;
}

function initQuery() {
  const form = document.getElementById('query-form');
  if (!form) return;
  const result = document.getElementById('query-result');
  const error = document.getElementById('query-error');
  const button = form.querySelector('button[type="submit"]');
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    error.textContent = '';
    result.hidden = true;
    button.disabled = true;
    try {
      const data = await requestJSON('/api/orders/query', { method: 'POST', body: new FormData(form) });
      result.replaceChildren();
      const summary = document.createElement('div');
      summary.className = 'query-result-summary';
      [
        ['商品', `${data.product_name} · ${data.variant_name}`],
        ['订单金额', `¥${yuan(data.total_amount_cents)}`],
        ['支付状态', statusLabel(data.payment_status)],
        ['履约状态', statusLabel(data.fulfillment_status)],
      ].forEach(([label, value]) => {
        const cell = document.createElement('div');
        appendText(cell, 'span', label);
        appendText(cell, 'strong', value);
        summary.appendChild(cell);
      });
      result.appendChild(summary);
      if (data.payment_status === 'paid' && data.fulfillment_status === 'delivered') {
        const list = document.createElement('div');
        list.className = 'delivered-cards';
        renderCards(list, data.cards || []);
        result.appendChild(list);
      } else {
        const note = appendText(result, 'div', '', 'inline-warning');
        note.textContent = data.fulfillment_status === 'exception'
          ? '付款已确认，当前正在人工处理，请稍后再次查询。'
          : data.payment_status === 'pending'
            ? '订单仍在等待付款，可返回收银台继续完成支付。'
            : '当前订单没有可交付的卡密。';
      }
      result.hidden = false;
    } catch (exception) {
      error.textContent = exception.message;
    } finally {
      button.disabled = false;
    }
  });
}

function initAdminActions() {
  const sidebar = document.getElementById('admin-sidebar');
  document.querySelector('[data-sidebar-toggle]')?.addEventListener('click', () => sidebar?.classList.toggle('open'));

  document.querySelectorAll('[data-post-url]').forEach((button) => {
    button.addEventListener('click', () => {
      if (button.dataset.confirm && !window.confirm(button.dataset.confirm)) return;
      const form = document.createElement('form');
      form.method = 'post';
      form.action = button.dataset.postUrl;
      const token = document.createElement('input');
      token.type = 'hidden'; token.name = '_token'; token.value = csrfToken;
      form.appendChild(token);
      document.body.appendChild(form);
      form.submit();
    });
  });
  document.querySelectorAll('form [data-confirm]').forEach((button) => {
    button.closest('form')?.addEventListener('submit', (event) => {
      if (!window.confirm(button.dataset.confirm || '确认继续？')) event.preventDefault();
    });
  });
  document.querySelector('[data-check-all]')?.addEventListener('change', (event) => {
    document.querySelectorAll('input[name="ids[]"]:not(:disabled)').forEach((checkbox) => { checkbox.checked = event.target.checked; });
  });

  const dialog = document.getElementById('card-dialog');
  document.querySelectorAll('[data-reveal-card]').forEach((button) => {
    button.addEventListener('click', async () => {
      button.disabled = true;
      try {
        const data = await requestJSON(`/admin/cards/${button.dataset.revealCard}/reveal`, { method: 'POST' });
        document.getElementById('revealed-secret').textContent = data.secret || '';
        document.getElementById('revealed-buyer-note').textContent = data.buyer_note || '—';
        document.getElementById('revealed-internal-note').textContent = data.internal_note || '—';
        dialog?.showModal();
      } catch (exception) {
        showToast(exception.message, 'error');
      } finally {
        button.disabled = false;
      }
    });
  });
  document.querySelector('[data-close-dialog]')?.addEventListener('click', () => dialog?.close());
}

function initVariantEditor() {
  const editor = document.getElementById('variant-editor');
  const add = document.querySelector('[data-add-variant]');
  if (!editor || !add) return;

  const reindex = () => {
    editor.querySelectorAll('[data-variant-row]').forEach((row, index) => {
      row.querySelectorAll('[data-field]').forEach((field) => { field.name = `variants[${index}][${field.dataset.field}]`; });
    });
  };
  const bindRemove = (button) => button.addEventListener('click', () => {
    if (editor.querySelectorAll('[data-variant-row]').length <= 1) {
      showToast('商品至少需要一个规格', 'error');
      return;
    }
    button.closest('[data-variant-row]')?.remove();
    reindex();
  });
  editor.querySelectorAll('[data-remove-variant]').forEach(bindRemove);
  add.addEventListener('click', () => {
    const row = document.createElement('div');
    row.className = 'variant-editor-row';
    row.dataset.variantRow = '';
    row.innerHTML = '<span class="drag-handle">⋮⋮</span><input type="hidden" data-field="id" value="0"><label>规格名<input class="input" data-field="name" required></label><label>售价（元）<input class="input" data-field="price" value="1.00" inputmode="decimal" required></label><label>最少购买<input class="input" data-field="min_quantity" type="number" min="1" value="1"></label><label>最多购买<input class="input" data-field="max_quantity" type="number" min="1" value="10"></label><label>排序<input class="input" data-field="sort_order" type="number" value="0"></label><label class="mini-switch labeled"><input data-field="status" type="checkbox" value="1" checked><i></i><span>启用</span></label><button class="icon-button danger" type="button" data-remove-variant title="移除规格">×</button>';
    editor.appendChild(row);
    bindRemove(row.querySelector('[data-remove-variant]'));
    reindex();
    row.querySelector('[data-field="name"]').focus();
  });
  reindex();
}

function initCardImportPreview() {
  const form = document.getElementById('card-import-form');
  if (!form) return;
  const error = document.getElementById('card-import-error');
  const button = form.querySelector('button[type="submit"]');
  form.addEventListener('submit', async (event) => {
    if (form.dataset.previewed === '1') return;
    event.preventDefault();
    error.textContent = '';
    button.disabled = true;
    button.textContent = '正在预检…';
    try {
      const data = await requestJSON('/admin/cards/preview', { method: 'POST', body: new FormData(form) });
      if (data.valid < 1) throw new Error('没有可导入的有效卡密');
      const sample = (data.samples || []).map((item) => `• ${item.secret_masked}${item.buyer_note ? `（${item.buyer_note}）` : ''}`).join('\n');
      const message = `预检完成：共 ${data.total} 条，可导入 ${data.valid} 条，重复 ${data.duplicates} 条，无效 ${data.invalid} 条。${sample ? `\n\n前 ${data.samples.length} 条预览：\n${sample}` : ''}\n\n确认导入可用记录吗？`;
      if (window.confirm(message)) {
        form.dataset.previewed = '1';
        form.requestSubmit();
        return;
      }
    } catch (exception) {
      error.textContent = exception.message;
    }
    button.disabled = false;
    button.textContent = '预检并导入';
  });
}

function initUploadPreview() {
  document.querySelectorAll('.upload-box input[type="file"]').forEach((input) => {
    input.addEventListener('change', () => {
      const file = input.files?.[0];
      if (!file || !file.type.startsWith('image/')) return;
      const box = input.closest('.upload-box');
      let image = box.querySelector('img');
      if (!image) {
        image = document.createElement('img');
        box.prepend(image);
        box.querySelectorAll(':scope > span, :scope > b, :scope > small').forEach((element) => element.remove());
      }
      image.src = URL.createObjectURL(file);
      image.alt = '待上传图片预览';
    });
  });
}

initPurchaseForm();
initCheckout();
initQuery();
initAdminActions();
initVariantEditor();
initCardImportPreview();
initUploadPreview();
